import React, { useState } from 'react';
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box, CircularProgress, Typography, } from '@mui/material';
import { globalPutService, globalPostService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { addWorkingApi, updateWorkingApi } from '../apiService';
import { PageLoader } from '../../../../shared_elements';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';

const WorkingGroupCRU = ({ workingGrpCRU, getResponseBack,fileUpload, onToggleModal, modeType, onOpenAttachments }) => {
    const { leaseSlug } = useParams();
    const dispatch=useDispatch()
    const { storageDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [data, setData] = useState(workingGrpCRU?.data)
    const [attachments, setAttachments] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
    }

    const onAddEditWorkingGroup = () => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            name: data?.name ? "" : "Please enter Name",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(updateWorkingApi({ ...params, slug: data?.slug }), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Working Group`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Working Group`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                globalPostService(addWorkingApi(params), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Working Group`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Working Group`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Working Group`, error_msg: validationInputs, })
        }
    };

const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType==='add'?'Add':modeType==='edit'?'Edit':'View'} Working Group`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                // onClose={onToggleModal}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Working Group" : modeType === 'edit' ? 'Edit Working Group' : 'View Working Group '}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="outlined-basic"
                                label="Name"
                                variant="outlined"
                                size='small'
                                fullWidth
                                required
                                error={error?.name || ""}
                                helperText={error?.name || ''}
                                onFocus={() => { setError(prev => ({ ...prev, name: '' })); }}
                                value={data?.name || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 100 ? onFieldChange("name", value.trimStart()) : e.preventDefault() : null
                                }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                            /> 
                        </Grid>
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                         <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ?
                                <Button onClick={()=>{onOpenAttachments();handleItemClicked('View Attachments Button')}} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({workingGrpCRU?.data?.attachments?.length})Attachment(s)</Button> : null
                            }
                              <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditWorkingGroup(); }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>

    )
}

export default WorkingGroupCRU